import React, { useState } from "react";
import styles from "../styles/Body.module.css";
import { FaCar, FaInfoCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { slugify } from "../utils/utils";
// Import car images
import شاهین from "../images/cars/shahin.png";
import تیبا from "../images/cars/tiba.png";
import پراید from "../images/cars/pride.png";
import پژو206 from "../images/cars/206.png";
import پرشیا from "../images/cars/pershia.png";
import سمند from "../images/cars/samand.png";
import پژو207 from "../images/cars/207.png";
import تارا from "../images/cars/tara.png";
import پژو405 from "../images/cars/405.png";
import کوییک from "../images/cars/quick.png";
import ساینا from "../images/cars/siana.png";
import اطلس from "../images/cars/atlas.jpg";

// IMPORTANT: Make sure this slugify is the same one used in your ProductsAll.js
// If it's imported from '../utils/utils', use that instead of defining it here.

const Body = () => {
  const carGroups = [
    [
      {
        image: سمند,
        name: "سمند",
        batteryText: "66 آمپر", // Display text for battery
        // CORRECTED: Link to a relevant car battery product
        productName: "باتری واریان صبا 66 آمپر (Varian 66)",
        alt: "باتری مناسب خودرو سمند - باطری مخصوص سمند - مشخصات فنی باتری سمند",
      },
      {
        image: پژو405,
        name: "پژو 405",
        batteryText: "66 آمپر",
        productName: "باتری واریان صبا 66 آمپر (Varian 66)",
        alt: "باتری مناسب خودرو پژو 405 - باطری مخصوص پژو 405 - مشخصات فنی باتری پژو 405",
      },
      {
        image: پژو206,
        name: "پژو 206",
        batteryText: "باتری واریان صبا 50 آمپر (Varian 50 L1)",
        productName: "باتری 50 آمپر واریان",
        alt: "باتری مناسب خودرو پژو 206 - باطری مخصوص پژو 206 - مشخصات فنی باتری پژو 206",
      },
      {
        image: پژو207,
        name: "پژو 207",
        batteryText: "50 آمپر",
        productName: "باتری واریان صبا 50 آمپر (Varian 50 L1)",
        alt: "باتری مناسب خودرو پژو 207 - باطری مخصوص پژو 207 - مشخصات فنی باتری پژو 207",
      },
      {
        image: پرشیا,
        name: "پرشیا",
        batteryText: "66 آمپر",
        productName: "باتری واریان صبا 66 آمپر (Varian 66)",
        alt: "باتری مناسب خودرو پرشیا - باطری مخصوص پرشیا - مشخصات فنی باتری پرشیا",
      },
      {
        image: تارا,
        name: "تارا",
        batteryText: "66 آمپر",
        productName: "باتری واریان صبا 66 آمپر (Varian 66)",
        alt: "باتری مناسب خودرو تارا - باطری مخصوص تارا - مشخصات فنی باتری تارا",
      },
    ],
    [
      {
        image: پراید,
        name: "پراید",
        batteryText: "50 آمپر",
        productName: "باتری واریان صبا 50 آمپر (Varian 50 L1)",
        alt: "باتری مناسب خودرو پراید - باطری مخصوص پراید - مشخصات فنی باتری پراید",
      },
      {
        image: تیبا,
        name: "تیبا",
        batteryText: "50 آمپر",
        productName: "باتری واریان صبا 50 آمپر (Varian 50 L1)",
        alt: "باتری مناسب خودرو تیبا - باطری مخصوص تیبا - مشخصات فنی باتری تیبا",
      },
      {
        image: کوییک,
        name: "کوییک",
        batteryText: "50 آمپر",
        productName: "باتری واریان صبا 50 آمپر (Varian 50 L1)",
        alt: "باتری مناسب خودرو کوییک - باطری مخصوص کوییک - مشخصات فنی باتری کوییک",
      },
      {
        image: ساینا,
        name: "ساینا",
        batteryText: "50 آمپر",
        productName: "باتری واریان صبا 50 آمپر (Varian 50 L1)",
        alt: "باتری مناسب خودرو ساینا - باطری مخصوص ساینا - مشخصات فنی باتری ساینا",
      },
      {
        image: اطلس,
        name: "اطلس",
        batteryText: "50 آمپر",
        productName: "باتری واریان صبا 50 آمپر (Varian 50 L1)",
        alt: "باتری مناسب خودرو اطلس - باطری مخصوص اطلس - مشخصات فنی باتری اطلس",
      },
      {
        image: شاهین,
        name: "شاهین",
        batteryText: "60 آمپر", // Example: linking to a 60Ah battery
        productName: "باتری واریان صبا 60 آمپر پایه کوتاه (Varian 60)",
        alt: "باتری مناسب خودرو شاهین - باطری مخصوص شاهین - مشخصات فنی باتری شاهین",
      },
    ],
  ];

  const [activeGroup, setActiveGroup] = useState(null);
  const [activeCarIndex, setActiveCarIndex] = useState(null);

  const handleCarClick = (groupIndex, carIndex) => {
    if (activeGroup === groupIndex && activeCarIndex === carIndex) {
      setActiveGroup(null);
      setActiveCarIndex(null);
    } else {
      setActiveGroup(groupIndex);
      setActiveCarIndex(carIndex);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FaCar className={styles.headerIcon} />
        <h1>باتری مناسب تمامی خودروهای ایرانی و خارجی</h1>
      </div>

      {carGroups.map((group, groupIndex) => (
        <div key={groupIndex} className={styles.carGroup}>
          <div className={styles.carGrid}>
            {group.map((car, carIndex) => (
              <div
                key={carIndex}
                className={styles.carCard}
                onClick={() => handleCarClick(groupIndex, carIndex)}
              >
                <img
                  src={car.image}
                  alt={car.alt}
                  title={`مشخصات باتری ${car.name}`}
                  className={styles.carImage}
                />
                <p className={styles.carName}>{car.name}</p>
              </div>
            ))}
          </div>

          {activeGroup === groupIndex && activeCarIndex !== null && (
            <div className={styles.infoPanel}>
              <FaInfoCircle className={styles.infoIcon} />
              <p className={styles.carInfo}>
                <strong>{group[activeCarIndex].name}:</strong>{" "}
                <Link
                  to={`/product/${slugify(group[activeCarIndex].productName)}`}
                  className={styles.batteryAmperageLink}
                >
                  باتری مناسب {group[activeCarIndex].batteryText}
                </Link>
              </p>
              <Link to="/محصولات/"> مشاهده محصولات مرتبط</Link>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Body;
